import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { copyTextToClipboard } from "../utils/clipboard";
import { buildBandShareUrl } from "../utils/bandRoutes";

export default function useBandShare(band) {
    const { t } = useTranslation();
    const toastIdRef = useRef(0);
    const [toast, setToast] = useState(null);

    const showToast = useCallback((message, type = "info") => {
        toastIdRef.current += 1;
        setToast({
            id: toastIdRef.current,
            message,
            type,
        });
    }, []);

    const shareBand = useCallback(async () => {
        const shareUrl = buildBandShareUrl(band);
        if (!shareUrl) {
            showToast(t("bandPage.share.toasts.unavailable"), "error");
            return false;
        }

        try {
            await copyTextToClipboard(shareUrl);
            showToast(t("bandPage.share.toasts.copied"), "success");
            return true;
        } catch (error) {
            console.warn("Failed to copy band URL to clipboard.", error);
            showToast(t("bandPage.share.toasts.failed"), "error");
            return false;
        }
    }, [band, showToast, t]);

    const clearToast = useCallback(() => {
        setToast(null);
    }, []);

    return {
        shareBand,
        bandShareToast: toast,
        clearBandShareToast: clearToast,
    };
}
